module.exports = __webpack_public_path__ + "assets/img/32_625.e26d918b.jpg";